import React, { useState, useEffect } from 'react'
import { BiRefresh } from 'react-icons/bi'
import { RiSettings5Line } from 'react-icons/ri'
import { motion, AnimatePresence } from 'framer-motion'
import ReactCardFlip from 'react-card-flip'
import tinycolor from 'tinycolor2'
import * as RemixIcon from 'react-icons/ri'
import Classnames from 'classnames'

// state
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'
import { section } from '@/store/template/section'

function ShortText({ id, contentID, sectionData, wrapperId }) {
  const [showAnswer, toggleAnswer] = useState(false)

  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] =
    useRecoilState(editSectionWrapperId)
  const [getSection, setSection] = useRecoilState(section(id))

  const title_color_hex = tinycolor(sectionData.title_color)
  let text_color = 'black'
  if (title_color_hex.isDark()) {
    text_color = 'white'
  }
  const openEditor = () => {
    if (isBuilderApp) {
      setScreen('editsection')
      setScreenOpen(true)
      setEditSectionId(id)
      setEditSectionWrapperId(wrapperId)
    }
  }

  let IconComponent = RemixIcon['RiFileEditLine']

  if (getSection.icon !== 'noicon') {
    IconComponent = RemixIcon[getSection.icon]
  }

  return (
    <div className="relative flipCardSection p-5 flex flex-col justify-center h-full">
      {/* edit icon */}
      {isBuilderApp && (
        <div
          onClick={openEditor}
          className="editSectionIcon opacity-0 absolute top-3 right-3 z-10  hover:opacity-100 hover:shadow p-1 text-lg rounded  hover:bg-blue-500 hover:text-white cursor-pointer"
          style={{ zIndex: '999999' }}
        >
          <RiSettings5Line />
        </div>
      )}

      <ReactCardFlip
        isFlipped={showAnswer}
        infinite={true}
        containerStyle={{ height: '100%' }}
      >
        <div
          onClick={() => {
            toggleAnswer(true)
          }}
          style={{
            backgroundColor: sectionData.title_color,
            color: text_color,
          }}
          className="flipCardFront  flipCardInner relative cursor-pointer rounded h-full flex-grow p-10 text-center flex flex-col justify-center"
        >
          {/* OPTIONAL ICON */}
          {getSection.icon !== 'noicon' && (
            <div className="w-full flex justify-center mb-4">
              <div
                className={Classnames(
                  'sectionIcon h-16 w-16 flex-shrink-0 text-4xl flex items-center justify-center',
                  {
                    rounded: getSection.iconstyle == 'square',
                    'rounded-full': getSection.iconstyle == 'circle',
                    ' bg-gray-100 text-gray-600':
                      getSection.iconcolor == 'gray',
                    ' bg-blue-100 text-blue-500':
                      getSection.iconcolor == 'blue',
                    ' bg-green-100 text-green-600':
                      getSection.iconcolor == 'green',
                    ' bg-red-100 text-red-600': getSection.iconcolor == 'red',
                    ' bg-purple-100 text-purple-600':
                      getSection.iconcolor == 'purple',
                    ' bg-pink-100 text-pink-600':
                      getSection.iconcolor == 'pink',
                    ' bg-indigo-100 text-indigo-600':
                      getSection.iconcolor == 'indigo',
                    ' bg-yellow-100 text-yellow-600':
                      getSection.iconcolor == 'yellow',
                    ' bg-gray-600 text-gray-50':
                      getSection.iconcolor == 'darkgray',
                    ' bg-green-500 text-green-50':
                      getSection.iconcolor == 'darkgreen',
                    ' bg-blue-500 text-blue-50':
                      getSection.iconcolor == 'darkblue',
                    ' bg-red-500 text-red-50':
                      getSection.iconcolor == 'darkred',
                    ' bg-purple-500 text-purple-50':
                      getSection.iconcolor == 'darkpurple',
                    ' bg-pink-500 text-pink-50':
                      getSection.iconcolor == 'darkpink',
                    ' bg-indigo-500 text-indigo-50':
                      getSection.iconcolor == 'darkindigo',
                    ' bg-yellow-400 text-yellow-50':
                      getSection.iconcolor == 'darkyellow',

                    ' text-gray-700':
                      getSection.iconcolor == 'darkgray' &&
                      getSection.iconstyle == 'icononly',
                    ' text-green-700':
                      getSection.iconcolor == 'darkgreen' &&
                      getSection.iconstyle == 'icononly',
                    ' text-blue-700':
                      getSection.iconcolor == 'darkblue' &&
                      getSection.iconstyle == 'icononly',
                    ' text-red-700':
                      getSection.iconcolor == 'darkred' &&
                      getSection.iconstyle == 'icononly',
                    ' text-purple-700':
                      getSection.iconcolor == 'darkpurple' &&
                      getSection.iconstyle == 'icononly',
                    ' text-pink-700':
                      getSection.iconcolor == 'darkpink' &&
                      getSection.iconstyle == 'icononly',
                    ' text-indigo-700':
                      getSection.iconcolor == 'darkindigo' &&
                      getSection.iconstyle == 'icononly',
                    ' text-yellow-700':
                      getSection.iconcolor == 'darkyellow' &&
                      getSection.iconstyle == 'icononly',
                    sectionIconNoBG: getSection.iconstyle == 'icononly',
                  }
                )}
              >
                <IconComponent />
              </div>
            </div>
          )}
          <h2 className="font-bold mb-1 text-xl">{sectionData.data.title}</h2>
          <p className="">{sectionData.data.subtitle}</p>
          <div className="absolute bottom-3 right-3 opacity-30 text-2xl">
            <BiRefresh />
          </div>
        </div>

        <div
          onClick={() => {
            toggleAnswer(false)
          }}
          className="flipCardFront flipCardInner text-black flipCardBack relative h-full cursor-pointer rounded  flex-grow px-10 text-center flex flex-col justify-center"
        >
          <h2 className="font-bold mb-1 text-xl">
            {sectionData.data.answer_title}
          </h2>
          <p className="">{sectionData.data.answer_subtitle}</p>
          <div className="absolute bottom-3 right-3 opacity-30 text-2xl">
            <BiRefresh />
          </div>
        </div>
      </ReactCardFlip>
    </div>
  )
}

export default ShortText
